import { AsetMasterApi, KondisiAsetApi } from "api"
import { ActionButton, Alert, SelectSearch } from "components"
import { UpdateModal } from "components/Modal"
import { InfoItemHorizontal, TextArea } from "components2"
import { monthOptions } from "constants/month"
import { yearOptions } from "constants/year"
import { Formik } from "formik"
import { useEffect, useState } from "react"
import { Col, ModalBody, ModalFooter, Row } from "react-bootstrap"
import { monthConvert } from "utilities/DateConvert/MonthConvert"
import * as Yup from 'yup'

export const NonaktifAset = ({ data, show, refetch, onHide, }) => {
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    text: '',
    variant: 'primary',
  })

  const [kondisiAset, setKondisiAset] = useState({
    loading: false,
    data: [],
  })

  const formValidationSchema = Yup.object().shape({
    id_grup_aset: Yup.string().required('Pilih Grup Aset'),
    id_item_aset: Yup.string().required('Pilih Item Aset'),
    tahun_nonaktif: Yup.string().required('Pilih Tahun Non-aktif'),
    bulan_nonaktif: Yup.string().required('Pilih Bulan Non-aktif'),
    id_kondisi_aset: Yup.string().required('Pilih Kondisi Aset'),
    keterangan_nonaktif: Yup.string().optional()
  })

  const formInitialValues = {
    id_grup_aset: data?.id_grup_aset,
    id_item_aset: data?.id_item_aset,
    tahun_nonaktif: data?.tahun_nonaktif,
    bulan_nonaktif: data?.bulan_nonaktif,
    id_kondisi_aset: data?.id_kondisi_aset,
    keterangan: data?.keterangan,
  }

  const formSubmitHandler = (values) => {
    AsetMasterApi.update(values)
      .then(() => {
        setAlertConfig({
          show: true,
          variant: 'primary',
          text: 'Ubah data berhasil!',
        })
        refetch()
      })
      .catch((err) => {
        setAlertConfig({
          show: true,
          variant: 'danger',
          text: `Ubah data gagal! (${err?.response?.data?.message})`,
        })
      })
      .finally(() => onHide()
      )
  }

  const getData = async () => {
    try {
      setKondisiAset({
        loading: true,
        data: [],
      })

      const res = await KondisiAsetApi.dropdown()

      setKondisiAset({
        loading: false,
        data: res.data?.data ?? [],
      })
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (show) {
      getData()
    }
  }, [show])

  return (
    <UpdateModal
      show={show}
      onHide={onHide}
    >
      <Formik
        initialValues={formInitialValues}
        validationSchema={formValidationSchema}
        onSubmit={formSubmitHandler}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          handleChange,
          handleSubmit,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            <ModalBody>
              {alertConfig.show && (
                <Alert
                  {...alertConfig}
                  showCloseButton={true}
                  onClose={() => setAlertConfig({ ...alertConfig, show: false })}
                />
              )}

              <Row className="mb-3">
                <Col>
                  <InfoItemHorizontal
                    label="Grup Aset"
                    text={data?.nama_grup_aset}
                  />
                  <InfoItemHorizontal
                    label="Kategori Aset"
                    text={data?.nama_kategori_aset}
                  />
                  <InfoItemHorizontal
                    label="Jenis Aset"
                    text={data?.nama_jenis_aset}
                  />
                  <InfoItemHorizontal
                    label="Kode Item Aset"
                    text={data?.kode_item_aset}
                  />
                  <InfoItemHorizontal
                    label="Nama Item Aset"
                    text={data?.nama_item_aset}
                  />
                  <InfoItemHorizontal
                    label="Bulan Perolehan"
                    text={monthConvert(data?.bulan_perolehan)}
                  />
                  <InfoItemHorizontal
                    label="Tahun Perolehan"
                    text={data?.tahun_perolehan}
                  />
                  <InfoItemHorizontal
                    label="Kondisi Saat Ini"
                    text={data?.nama_kondisi_aset}
                  />
                </Col>
              </Row>


              <SelectSearch
                key={values.tahun_perolehan}
                label="Tahun Non-aktif"
                placeholder="Pilih data"
                defaultValue={yearOptions.find(
                  (val) => val.value === values.tahun_perolehan
                )}
                option={yearOptions}
                isOptionDisabled={(option) => parseInt(option.value) < parseInt(data?.tahun_perolehan)}
                onChange={(val) => {
                  setFieldValue('tahun_nonaktif', val.value)
                }}
                error={
                  errors.tahun_nonaktif &&
                  touched.tahun_nonaktif &&
                  true
                }
                errorText={
                  errors.tahun_nonaktif &&
                  touched.tahun_nonaktif &&
                  errors.tahun_nonaktif
                }
              />

              <SelectSearch
                key={values.bulan_perolehan}
                label="Bulan Non-aktif"
                placeholder="Pilih data"
                isOptionDisabled={(option) => parseInt(values.tahun_nonaktif) === parseInt(data?.tahun_perolehan) ? parseInt(option.value) < parseInt(data?.bulan_perolehan) : false}
                defaultValue={monthOptions.find(
                  (val) => parseInt(val.value) === parseInt(values.bulan_nonaktif)
                )}
                option={monthOptions}
                onChange={(val) => {
                  setFieldValue('bulan_nonaktif', val.value)
                }}
                error={
                  errors.bulan_nonaktif &&
                  touched.bulan_nonaktif &&
                  true
                }
                errorText={
                  errors.bulan_nonaktif &&
                  touched.bulan_nonaktif &&
                  errors.bulan_nonaktif
                }
              />

              <SelectSearch
                label="Kondisi Aset"
                name="id_kondisi_aset"
                placeholder="Pilih data"
                loading={kondisiAset.loading}
                option={kondisiAset.data?.map((val) => {
                  return {
                    value: val.id_kondisi_aset,
                    label: val.nama_kondisi_aset,
                  }
                })}
                onChange={(val) => {
                  setFieldValue('id_kondisi_aset', val.value)
                  setFieldValue('nama_kondisi_aset', val.label)
                }}
                error={
                  errors.id_kondisi_aset &&
                  touched.id_kondisi_aset &&
                  true
                }
                errorText={
                  errors.id_kondisi_aset &&
                  touched.id_kondisi_aset &&
                  errors.id_kondisi_aset
                }
              />

              <TextArea
                label="Keterangan Non-aktif"
                type="text"
                name="keterangan_nonaktif"
                value={values.keterangan_nonaktif}
                onChange={handleChange}
                rows={2}
              />
            </ModalBody>

            <ModalFooter>
              <ActionButton
                type="button"
                variant="outline-secondary"
                text="Kembali"
                onClick={onHide}
              />

              <ActionButton
                type="submit"
                variant="danger"
                text="Non-aktif"
                loading={isSubmitting}
              />
            </ModalFooter>
          </form>
        )}
      </Formik>
    </UpdateModal>
  )
}